export enum AuditLogActionTypes {
  GET_AUDIT_LOGS = "@@AUDIT_LOG/GET_AUDIT_LOGS",
  GET_AUDIT_LOGS_SUCCESS = "@@AUDIT_LOG/GET_AUDIT_LOGS_SUCCESS",
  GET_AUDIT_LOGS_FAILURE = "@@AUDIT_LOG/GET_AUDIT_LOGS_FAILURE",

  GET_AUDIT_LOG_FILTERS = "@@AUDIT_LOG/GET_AUDIT_LOG_FILTERS",
  GET_AUDIT_LOG_FILTERS_SUCCESS = "@@AUDIT_LOG/GET_AUDIT_LOG_FILTERS_SUCCESS",
  GET_AUDIT_LOG_FILTERS_FAILURE = "@@AUDIT_LOG/GET_AUDIT_LOG_FILTERS_FAILURE",

  GET_AUDIT_LOG_DETAIL = "@@AUDIT_LOG/GET_AUDIT_LOG_DETAIL",
  GET_AUDIT_LOG_DETAIL_SUCCESS = "@@AUDIT_LOG/GET_AUDIT_LOG_DETAIL_SUCCESS",
  GET_AUDIT_LOG_DETAIL_FAILURE = "@@AUDIT_LOG/GET_AUDIT_LOG_DETAIL_FAILURE",

  SET_FILTER = "@@AUDIT_LOG/SET_FILTER",
  CLEAR_AUDIT_LOGS = "@@AUDIT_LOG/CLEAR_AUDIT_LOGS",
  CLEAR_DETAIL = "@@AUDIT_LOG/CLEAR_DETAIL",
}
